import styled from 'styled-components';


export const Header = styled.header`
  display: flex;

  align-items: center;

  justify-content: space-between;

  a {

    display: flex;

    align-items: center;
    text-decoration: none;
    transition: all 0.2s ease-in-out;

    color: #a8a8b3;

    svg {
      margin-right: 4px;

    }

    &:hover {
      color: #666
    }
  }

`;


export const RepositoryInfo = styled.section`
  margin-top: 80px;

  header {
    display: flex;
    align-items: center;

    img {
      width: 120px;
      height: 120px;

      border-radius: 50%;
    }

    div {
      margin-left: 24px;

      strong {
        font-size: 36px;
        color: #3d3d4d;
      }

      p {
        font-size: 18px;
        color: #737380;

        margin-top: 4px;
      }
    }

  }
    ul {
      display: flex;
      list-style: none;

      margin-top: 40px;


      li {
        & + li {
        margin-left: 80px;
        }
        strong {
          display: block;
          font-size: 36px;

          color: #3d3d4d;
        }

        span {
          display: block;
          margin-top: 4px;
          color: #6c6c80;
        }
      }
    }
`;


export const Issues = styled.div`
  margin-top: 80px;
  display: block;

  a {
    background: #fff;
    width: 100%;
    padding: 24px;
    border-radius: 5px;
    text-decoration: none;

    display: flex;
    align-items: center;
    transition: all 0.2s ease-in-out;

    &:hover {
      transform: translateX(5px);
    }

    & + a {
      margin-top: 15px;
    }

    div {
      margin-left: 16px;
      flex: 1;

      strong {
        font-size: 20px;
        color: #3d3d4d;
      }

      p {
        margin: 0;
        padding: 0;
        font-size: 18px;
        color: #a8a8b3;

        margin-top: 4px;
      }
    }

    svg {
      margin-left: auto;
    }
  }
`;
